import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsDialogSubmitted = ({
  blockId,
  blockVariationId,
  settingsId,
  tabId,
  elementType,
  changedTraits = {},
}) => {
  if (!blockId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_DIALOG_SUBMITTED, {
    blockId,
    blockVariationId,
    settingsId,
    tabId,
    elementId: elementType,
    ...(Object.keys(changedTraits).length && {
      changedOptions: changedTraits,
    }),
  });
};

export default trackElementSettingsDialogSubmitted;
